import { render, staticRenderFns } from "./create-team.vue?vue&type=template&id=7dde60b0&"
import script from "./create-team.ts?vue&type=script&lang=js&"
export * from "./create-team.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports